import { render, staticRenderFns } from "./report-on-demand.vue?vue&type=template&id=6caf5e36&scoped=true&"
import script from "./report-on-demand.vue?vue&type=script&lang=ts&"
export * from "./report-on-demand.vue?vue&type=script&lang=ts&"
import style0 from "./report-on-demand.vue?vue&type=style&index=0&id=6caf5e36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caf5e36",
  null
  
)

export default component.exports